// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"32e86b13","129":"1d16c00e","295":"562b7bbc","384":"7924aa31","532":"6d671c02","674":"255b40c2","693":"692b2990","884":"63efa630","965":"f2f2a0f6","966":"c3dedc3c"}[chunkId] + ".chunk.js";
};